import instance from './instance';

export const createFeedbackRequest = data => instance.post('/feedback_requests', data);
